/* Vendor */

/* Fonts */
import './fonts/main.css';

/* Styles */
import './scss/main.scss';

import '../node_modules/sticky-sidebar/dist/sticky-sidebar.js';
//import MultiClamp from 'multi-clamp';
window.WaveSurfer = require("wavesurfer.js");
window.WaveSurfer.timeline = require('wavesurfer.js/dist/plugin/wavesurfer.timeline.min.js');
window.WaveSurfer.minimap = require('wavesurfer.js/dist/plugin/wavesurfer.minimap.min.js');
window.WaveSurfer.cursor = require('wavesurfer.js/dist/plugin/wavesurfer.cursor.min.js');

//window.WaveSurfer.cursor = require('wavesurfer.js/dist/plugin/wavesurfer.cursor.min.js');


/*
import WaveSurfer from 'wavesurfer.js';
import TimelinePlugin from 'wavesurfer.js/dist/plugin/wavesurfer.timeline.min.js';
import MinimapPlugin from 'wavesurfer.js/dist/plugin/wavesurfer.minimap.min.js';
//window.WaveSurfer = require("wavesurfer.js");
/*require('wavesurfer.js/dist/plugin/wavesurfer.timeline.min.js');
require('wavesurfer.js/dist/plugin/wavesurfer.regions.min.js');
require('wavesurfer.js/dist/plugin/wavesurfer.minimap.min.js');
/*import TimelinePlugin from 'wavesurfer.js/dist/plugin/wavesurfer.timeline.min.js';
import CursorPlugin from 'wavesurfer.js/dist/plugin/wavesurfer.cursor.min.js';
import MinimapPlugin from 'wavesurfer.js/dist/plugin/wavesurfer.minimap.min.js';*/

/* Scripts */

import '../node_modules/animejs/anime.min.js';
import './js/main';



//////////////////
// WEBPACK FOOTER
// ./app.js
// module id = 0
// module chunks = 0